import styled, { createGlobalStyle } from "styled-components";
import { buengiftFadeIn } from "components/giftcard/Keyframe";

export const GlobalStyle = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }
    .show-mobile {
        display:none;
    }

    body {
        background-color: #021539;
    }

    @media screen and (max-width: 768px) {
        .show-mobile {
            display:block;
        }
        .show-desktop {
            display:none!important;
        }
    }
`;

export const Page = styled.section`
    background: rgb(0, 49, 122);
    background: radial-gradient(
        circle,
        rgba(0, 49, 122, 1) 0%,
        rgba(0, 11, 31, 1) 100%
    );
    background-position: fixed;

    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;

    section {
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 20px;
    }
`;

export const Title = styled.h1`
    background-color: #fff;

    /* Create the gradient. */
    background-image: linear-gradient(180deg, #fff, #a2a2a2);

    /* Set the background size and repeat properties. */
    background-size: 100%;
    background-repeat: repeat;

    /* Use the text as a mask for the background. */
    /* This will show the gradient as a text color rather than element bg. */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;

    text-align: center;
    font-size: 100px;

    animation: ${buengiftFadeIn} 0.6s ease-in both;

    @media screen and (max-width: 600px) {
        font-size: 58px;
    }
`;

export const Subtitle = styled.h2`
    color: rgba(255, 238, 247, 0.6);
    text-align: center;
    font-size: 30px;
    font-weight: 300;
    scroll-margin-top: 30px;
    animation: ${buengiftFadeIn} 0.6s ease-in 0.1s both;

    @media screen and (max-width: 600px) {
        font-size: 26px;
    }
`;

export const DownloadApp = styled.a`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    padding: 12px 40px;
    border: 3px solid hsla(0, 0%, 100%, 0.3);
    background-clip: padding-box;
    background-color: #fff;
    border-radius: 8px;
    color: #0d0d0d;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.2px;
    line-height: 20px;
    cursor: pointer;
    transition: background-color 0.2s;

    /* @media screen and (min-width: 540px) {
        display: ${({ showMobile }) => (showMobile ? "none" : "flex")};
    }

    @media screen and (max-width: 540px) {
        display: ${({ showMobile }) => (showMobile ? "flex" : "none")};
    } */
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
    padding: 10px 20px;
    transition: background 400ms ease 0s;

    @media screen and (max-width: 600px) {
        background: rgba(255, 255, 255, 0.08);
        backdrop-filter: saturate(180%) blur(5px);
        backface-visibility: hidden;
    }

    @media screen and (max-width: 540px) {
        justify-content: center;
    }

    @media screen and (max-width: 540px) {
        a {
            display: none;
        }
    }

`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size: 14px;
    text-align:center;

    p {
        color: rgba(255, 238, 247, 0.6);
        margin: 0;
    }

    a {
        color: #fff;
        margin-left: 20px;
    }

    @media screen and (max-width: 520px) {
        flex-direction: column;
        justify-content: center;
        gap: 20px;
        text-align: center;

        p {
            order: 2;
        }
    }
`;

export const Video = styled.video`
    max-height: 80vh;
    border-radius: 12px;
    border: 5px solid hsla(0, 0%, 100%, 0.1);
    box-shadow: 0 0 30px rgb(0 0 0 / 50%);
    margin: 20px 0;
`;


export const SectionComoReclamar = styled.section`
`;
